import { defaultEthereumProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/ethereum/default-constants';

export const VERSE_CONTRACT_ADDRESS = '0xB4B0ea46Fe0E9e8EAB4aFb765b527739F2718671';

export const VERSE_PROVIDER_CONFIGURATION = defaultEthereumProviderConfiguration;
